import RibbonViewState from '../store/schema/RibbonViewState';
import getButtons from '../utils/getButtons';
import { action } from 'satcheljs/lib/legacy';

export const RIBBON_MARGIN = 46;

/**
 * This is the width of a ribbon button (30) + right margin (5)
 * Remember to update this when there is any change to ribbon UX
 */
export const RIBBONITEM_WIDTH = 36;

/**
 * This is the min number of visible items. The last one points to the font color
 * picker which we should not let collapse to happen beyond that point as the color
 * picker won't work in affordance. See VSO 11855: fabric to support callout in callout
 */
export const MIN_VISIBLE_ITEMS = 8;

let updateRibbonVisibleItemCount = action('updateRibbonWidth')(function updateRibbonWidth(
    viewState: RibbonViewState,
    count: number
) {
    viewState.visibleItemCount = count;
});

export default function updateRibbonWidth(viewState: RibbonViewState, width: number) {
    width -= RIBBON_MARGIN;

    let availableSlots = Math.floor(width / RIBBONITEM_WIDTH);
    availableSlots = Math.max(availableSlots, MIN_VISIBLE_ITEMS);
    availableSlots = Math.min(availableSlots, getButtons().length);
    if (availableSlots != viewState.visibleItemCount) {
        updateRibbonVisibleItemCount(viewState, availableSlots);
    }
}
